import * as types from "./mutation-types"
import "./state-types"

export default {
  [types.SAVE_ROUTE_ITEM](state: routeItemState, obj: any) {
    state.routeItem = obj
    const routeItem = state.routeItems.find((el: any) => el.id === obj.id)
    if (!routeItem) {
      state.routeItems.push(obj)
    }
  },
  [types.SAVE_ROUTE_ITEMS](state: routeItemState, obj: any) {
    state.routeItems = obj
  },
  [types.add_route_item](state: any, obj: any) {
    const index = state.routeItems.findIndex((el: any) => el.uuid == obj.uuid)
    if (index >= 0) {
      state.routeItems.splice(index, 1, {
        ...state.routeItems[index],
        id: obj.id,
      })
    } else {
      state.routeItems.push(obj)
    }
  },
  [types.SAVE_JOBS](state: routeItemState, obj: any) {
    obj = obj.map((job: Record<any, any>) => {
      job.description = `${job.code} - ${job.description}`
      return job
    })
    localStorage.setItem("jobs", JSON.stringify(obj))
    state.jobs = obj
  },
  [types.SAVE_ABNORMALITIES](state: routeItemState, obj: any) {
    obj = obj.map((abnormality: Record<string, string>) => {
      abnormality.description = `${abnormality.code} - ${abnormality.description}`
      return abnormality
    })
    localStorage.setItem("abnormalities", JSON.stringify(obj))

    state.abnormalities = obj
  },
  [types.SAVE_SERVICE_TYPES](state: routeItemState, obj: any) {
    localStorage.setItem("service_types", JSON.stringify(obj))
    state.service_types = obj
  },
  [types.SAVE_PROVIDERS](state: routeItemState, obj: any) {
    localStorage.setItem("providers", JSON.stringify(obj))
    state.providers = obj
  },
  [types.UPDATE_ROUTE_ITEM](state: routeItemState, obj: any) {
    for (const index in state.routeItems) {
      if (state.routeItems[index].id == obj.id) {
        state.routeItems.splice(index, 1, obj)
      }
    }
  },
  [types.finished_route_item](state: routeItemState, obj: any) {
    for (const index in state.routeItems) {
      if (state.routeItems[index].id == obj.id) {
        state.routeItems.splice(index, 1, {
          ...state.routeItems[index],
          finished: true,
        })
      }
    }
  },
  [types.save_reason_for_not_signing](state: routeItemState, obj: Object[]) {
    localStorage.setItem("reason_for_not_signings", JSON.stringify(obj))
    state.reason_for_not_signings = obj
  },
}
